import React from "react";
import style from "./Overlay.module.css";

const Overlay = () => {
  return <div className={style.overlay}></div>;
};

export default Overlay